module.exports = __webpack_public_path__ + "static/media/p10.f28f3916.jpg";